<template>
  <button
    type="button"
    class="flex cursor-pointer items-center gap-1 rounded-lg border border-border bg-white p-1 px-2 text-[0.625rem] font-semibold uppercase text-gray-500 transition-colors hover:border-border hover:bg-gray-100 dark:bg-muted dark:text-white dark:hover:bg-muted"
  >
    <slot />
  </button>
</template>
